module.exports = __webpack_public_path__ + "img/vehicle-trend.0e497ccd.png";